import { inject } from 'vue'
import {
  type ConfigInjectionValue,
  CONFIG_INJECTION_KEY
} from '@/ui-core/plugin/config'

export const useConfig = () => {
  const injectionValue = inject<ConfigInjectionValue>(CONFIG_INJECTION_KEY)

  if (!injectionValue) {
    throw new ReferenceError('Config is not provided')
  }

  return injectionValue
}
